<template>
  
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'VictimListener',

  computed: {
    ...mapGetters({
      //Authenticated User
      user: 'auth/user',
    }),
  },

  methods: {
    ...mapActions({
      //Make Notifcation
      newVictim : 'notification/newVictim',
      addVictim : 'victims/addVictim'
    }),

    playSound(){
      let audio = new Audio('/notify.mp3');
      audio.play();
    }
  },

  /**
  * Listen on Victim channel
  */
  created(){
  	window.Echo.private('Victims.'+this.user.id)
    .listen('NewVictim', (victim) => {
      this.addVictim(victim);
      this.playSound();
      this.newVictim();
    })
    .listen('NewPrivateVictim', (victim) => {
      this.addVictim(victim);
      this.playSound();
      this.newVictim();
    });
  }
};
</script>
